import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {withRouter} from 'react-router-dom'
import {Modal, Button} from 'antd'

@withRouter
@inject('store') @observer
class LeaveModal extends Component {
  save = async () => {
    const {backtest, algo} = this.props.store
    backtest.editingAlgo = false
    backtest.editingAlgoLoading = true

    await algo.single.update()
    backtest.editingAlgoLoading = false
    this.props.close()
    if (this.props.leavePath) {
      this.props.history.push(this.props.leavePath)
    }
  }
  revert = () => {
    const {backtest, algo} = this.props.store
    algo.single.data = backtest.algoSnapshot
    this.save()
  }
  render() {
    const {algo} = this.props.store
    const {validatingSignal} = algo
    const {submitEnabled, loading} = algo.single
    return(
      <Modal
        visible={this.props.visible}
        title='Do you want to save changes?'
        onOk={this.save}
        onCancel={this.props.close}
        footer={[
          <Button key='back' onClick={this.props.close}>Cancel</Button>,
          <Button key='dont-save' disabled={loading} onClick={this.revert}>
            Don&apos;t save
          </Button>,
          <Button key='save' type='primary' loading={loading} disabled={!submitEnabled || validatingSignal} onClick={this.save}>
            Save
          </Button>
        ]}
      />
    )
  }
}

export default LeaveModal
